import { ValueOption } from "../../../../design-system/dropdown/selection-box/types"

export const sortCountryOptions = (countryOptions: ValueOption[]) =>
  [...countryOptions].sort((a: ValueOption, b: ValueOption) => {
    if (a.label === "United States") {
      return -1
    }
    if (b.label === "United States") {
      return 1
    }
    return a.label.localeCompare(b.label)
  })

const priorityLabels: string[] = ["USD", "CAD", "EUR", "GBP"]

export const sortCurrencyOptions = (currencyOptions: ValueOption[]) =>
  [...currencyOptions].sort((a: ValueOption, b: ValueOption) => {
    const aPriority = priorityLabels.indexOf(a.label)
    const bPriority = priorityLabels.indexOf(b.label)

    if (aPriority !== -1 && bPriority !== -1) {
      return aPriority - bPriority
    }

    if (aPriority !== -1) {
      return -1
    }

    if (bPriority !== -1) {
      return 1
    }

    return a.label.localeCompare(b.label)
  })
